<template>
  <modalDialog class="modal--personalized" @close="close">
    <p class="" slot="header">{{ $t("xpo.legalPersonalData.title") }}</p>
    <div slot="form" class="form">
      <!-- Information -->
      <div class="detail">
        <div class="detail__details">
          <div class="item">
            <span class="item__title">
              {{ $t("xpo.legalPersonalData.text1") }}
            </span>
          </div>
        </div>
        <div class="detail__details">
          <div class="item">
            <span class="item__title">
              {{ $t("xpo.legalPersonalData.text2") }}
            </span>
          </div>
        </div>
        <div class="detail__details">
          <div class="item">
            <span class="item__title">
              {{ $t("xpo.legalPersonalData.text3") }}
            </span>
          </div>
        </div>
        <div class="detail__details">
          <div class="item">
            <span class="item__title">
              {{ $t("xpo.legalPersonalData.text4") }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer">
      <button cancel class="btn btn--white modal__btn" @click="close">
        {{ $t("global.button.close") }}
      </button>
    </div>
  </modalDialog>
</template>

<script>
import modalDialog from "@/components/ModalDialogFrame.vue";

export default {
  components: {
    modalDialog
  },
  name: "DialogLegalPersonalData",
  data: () => ({}),
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style scoped>
.form {
  max-height: 50vh;
  overflow-y: auto;
}
.detail__details {
  margin-bottom: 1rem;
}
</style>
